module.exports = __webpack_public_path__ + "static/work53-9c0a9d1962e94fec873ec70ee1d64e8c.jpg";